import { render, staticRenderFns } from "./default.vue?vue&type=template&id=6dd06530&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutWrapper: require('/home/ubuntu/ct_frontend/components/layout/LayoutWrapper.vue').default})
